import { useEffect, useRef } from 'react';
import { IDealRoomPeople } from '@app/interfaces/deal-room-people';
import { IDealRoomShare } from '@app/interfaces/deal-room';
import { IClient } from '@app/interfaces/client';
import { MF_LABELS, mfSetVariable, mfTag, mfTrackSection } from '@app/utils/mouseflowTracker';

interface MouseflowWidgetProps {
  dealRoom: IDealRoomShare;
  people: IDealRoomPeople;
}

const MOUSEFLOW_SRC = '//cdn.mouseflow.com/projects/ac940453-3acc-4be9-8bb6-e8897167b7fc.js';

export const MouseflowWidget: React.FC<MouseflowWidgetProps> = ({ dealRoom, people }) => {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current || !people || !dealRoom) return;
    initializedRef.current = true;

    window._mfq = window._mfq || [];

    if (!document.querySelector(`script[src="${MOUSEFLOW_SRC}"]`)) {
      const mf = document.createElement('script');
      mf.type = 'text/javascript';
      mf.defer = true;
      mf.src = MOUSEFLOW_SRC;
      document.getElementsByTagName('head')[0].appendChild(mf);
    }

    mfSetVariable('DSR_ID', dealRoom?.id_num);
    mfSetVariable('BarOz_ID', dealRoom?.barozRoomNumber);
    mfSetVariable('Client_ID', (dealRoom?.client as IClient)?.id_num);
    mfSetVariable('Customer_ID', `${people?.id}`.trim());
    mfSetVariable('Device_Type', /Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop');
    mfSetVariable('Lang', document.documentElement.lang || 'he');
    if (dealRoom?.status != null) mfSetVariable('DealRoom_Status', dealRoom.status);

    mfTrackSection(MF_LABELS.landingSectionLabel);
    mfTag(MF_LABELS.landingLoaded);
    // Opening section is the default panel on landing — tag the Hebrew label.
    mfTrackSection('פתיחה');

    return () => {
      const injected = document.querySelector(`script[src="${MOUSEFLOW_SRC}"]`);
      if (injected) injected.remove();
    };
  }, [people, dealRoom]);

  return <></>;
};
